import React, { useState, useEffect } from 'react';
// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";

import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { DialogContentText } from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import { url, urlLive } from "../../constant";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { FormControl, FormControlLabel, Checkbox, InputLabel, Select, MenuItem, Stack } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

import dayjs from 'dayjs';
import 'dayjs/locale/en-gb'; // Import the locale for British English


// Function to handle tab changes
function Tables() {
  // State to handle tab selection
  const [selectedTab, setSelectedTab] = useState(0);

  // State for form data
  const [requestTypeName, setRequestTypeName] = useState("");
  const [editRequestTypeId, setEditRequestTypeId] = useState("");

  // State for validation errors
  const [errors, setErrors] = useState({ name: "" });

  // State for storing request types fetched from API
  const [requestTypes, setRequestTypes] = useState([]);

  const [loading, setLoading] = useState(false);  // Loading state for data
  const [formLoading, setFormLoading] = useState(false);  // Loading state for form submission

  // State for error handling in case of fetch failure
  const [error, setError] = useState("");

  // Dialog states for delete and edit confirmation
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [deleteRequestTypeId, setdeleteRequestTypeId] = useState(null);
  const [currentPageIndex, setCurrentPageIndex] = useState(0); // Manage pagination state
  const [selectItDev, setSelectItDev] = React.useState(true);
  const [isLoading, setIsLoading] = React.useState(false);

  const itDev = [
    { id: 1, name: "True" },
    { id: 2, name: "False" }
  ];


  const handleItDevChange = (event) => {
    // Get the selected IdRequestType from the event
    const selectedId = event.target.value;

    // Find the corresponding RequestType from the requestTypes array
    const selectedItDev = itDev.find((type) => type.id === selectedId);

    // Set the type and typeName state values
    setSelectItDev(selectedItDev.name == "True" ? true : false);


    // console.log("SelectItDev = ",selectItDev);

  };

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  // Form validation
  const validateForm = () => {
    const newErrors = { name: "" };
    let isValid = true;

    if (!requestTypeName) {
      newErrors.name = "Tipo Richiesta è obbligatoria";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  // Handle form submission
  const handleSubmit = () => {
    if (validateForm()) {

      console.log("Form submitted with:", { requestTypeName });

      setFormLoading(true);  // Show loader during form submission

      // Create a FormData object with the new category name
      const formData = new FormData();
      formData.append("RequestType", requestTypeName);
      formData.append("ItDev", selectItDev);

      var akLoginUser = JSON.parse(localStorage.getItem('user'));
      formData.append('CreationUser', `${akLoginUser.user.IdUser}`)

      // Configure the POST request
      const requestOptions = {
        method: "POST",
        body: formData,
        redirect: "follow",
      };

      // Send the POST request to create a new category
      fetch(`${url}auth/create-request-types`, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          setFormLoading(false);  // Hide loader after form submission
          if (result.success) {
            console.log(result);
            // Assuming the result includes a success status or newly created category
            setRequestTypes((prevRequestTypes) => [
              ...prevRequestTypes,
              {
                IdRequestType: result.request_type.IdRequestType,
                RequestType: requestTypeName,
                CreationDate: dayjs(result.request_type.CreationDate).format('DD-MM-YYYY'),
                CreationUser: result.request_type.CreationUser,

              },

            ]);

            getRequestTypes();
            setRequestTypeName("");  // Reset form after submission
            setSelectedTab(0);       // Switch back to the List tab
            console.log("Request Type added successfully:", result, result.category.CreationUser);
          } else {
            console.error("Error adding Request Type:", result);
          }
        })
        .catch((error) => {
          setFormLoading(false);  // Hide loader on error
          console.error("Error Request Type:", error)
        });
    }


  }


  // Fetch data for request types using useEffect
  useEffect(() => {

    setLoading(true);  // Show loader while fetching data
    const requestOptions = {
      method: "GET",
      redirect: "follow"
    };

    fetch(`${url}auth/get-request-types`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.message === "Request Types retrieved successfully.") {
          setRequestTypes(result.data); // Store the request types in state
        } else {
          setError("Failed to fetch data.");
        }
      })
      .catch((error) => {
        setError("Error fetching data");
        console.error(error);
      })
      .finally(() => {
        setLoading(false); // Data fetch completed
      });

  }, []);

  const getRequestTypes = () => {

    setLoading(true);  // Show loader when refreshing data
    const requestOptions = {
      method: "GET",
      redirect: "follow"
    };

    fetch(`${url}auth/get-request-types`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.message === "Request Types retrieved successfully.") {
          setRequestTypes(result.data); // Store the request types in state
        } else {
          setError("Failed to fetch data.");
        }
      })
      .catch((error) => {
        setError("Error fetching data");
        console.error(error);
      })
      .finally(() => {
        setLoading(false); // Data fetch completed
      });

  }

  const formatDate = (dateString) => {
    if (!dateString) {
      return '';
    }
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  // Columns for the DataTable component, adding Action column
  const columns = [
    { Header: "#", accessor: "IdRequestType" },
    { Header: "Tipologia Richieste", accessor: "RequestType" },
    { Header: "It Dev", accessor: "ItDev" },
    { Header: "Data creazione", accessor: "CreationDate" },
    { Header: "Utente Creazione", accessor: "CreationUser" },
    { Header: "Data aggiornamento", accessor: "UpdateDate" },
    { Header: "Utente aggiornamento", accessor: "UpdateUser" },
    {
      Header: "Actions",
      accessor: "actions",
      // Cell: ({ row }) => (
      //   <Box sx={{ display: 'flex', gap: 1 }}>
      //     {/* Edit Button */}
      //     <Button
      //       onClick={() => handleEdit(row.original)}
      //       variant="contained"
      //       color="primary"
      //       size="small"
      //       sx={{
      //         fontWeight: 'bold',
      //         padding: '8px 16px',
      //         color: '#fff',
      //         backgroundColor: '#1976d2',
      //         '&:hover': { backgroundColor: '#1565c0' },
      //       }}
      //     >
      //       Edit
      //     </Button>

      //     {/* Delete Button */}
      //     <Button
      //       onClick={() => handleDeleteDialogOpen(row.original.IdRequestType)}
      //       variant="contained"
      //       color="error"
      //       size="small"
      //       sx={{
      //         fontWeight: 'bold',
      //         padding: '8px 16px',
      //         backgroundColor: '#d32f2f',
      //         color: '#fff',
      //         '&:hover': { backgroundColor: '#c62828' },
      //       }}
      //     >
      //       Delete
      //     </Button>
      //   </Box>
      // )
    }

  ];

  // Transform the data into rows with action buttons
  const rows = requestTypes.map((requestType) => ({
    IdRequestType: requestType.IdRequestType,
    RequestType: requestType.RequestType,
    ItDev: requestType.ItDev ? "Yes" : "No",
    CreationUser: requestType.CreationUserName,
    // CreationDate: formatDate(requestType.CreationDate),
    CreationDate: requestType.CreationDate ? dayjs(requestType.CreationDate).format('DD-MM-YYYY') : '',
    UpdateUser: requestType.UpdateUserName,
    // UpdateDate: formatDate(requestType.UpdateDate), 
    UpdateDate: requestType.UpdateDate ? dayjs(requestType.UpdateDate).format('DD-MM-YYYY') : '',
    actions: (
      <Box sx={{ display: 'flex', gap: 1 }}>
        {/* Edit Button */}
        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={() => handleEditDialogOpen(requestType)}
          sx={{
            fontWeight: 'bold',
            padding: '8px 16px',
            color: '#fff',
            // backgroundColor: '#1976d2',
            backgroundColor: '#183759',
            '&:hover': { 
              // backgroundColor: '#1565c0',
              backgroundColor: '#204b80',
             },
          }}
        >
          {/* Edit */}
          Modifica
        </Button>

        {/* Delete Button */}
        <Button
          variant="contained"
          color="error"
          size="small"
          onClick={() => handleDeleteDialogOpen(requestType.IdRequestType)}
          sx={{
            fontWeight: 'bold',
            padding: '8px 16px',
            backgroundColor: '#d32f2f',
            color: '#fff',
            '&:hover': { backgroundColor: '#c62828' },
          }}
          disabled={requestType.active}
        >
          {/* Delete */}
          Cancella
        </Button>
      </Box>
    ),
  }));


  // console.log(rows);

  // Function to open the Edit dialog
  const handleEditDialogOpen = (data) => {
    // Open your Edit dialog and pass the data for editing
    setRequestTypeName(data.RequestType);
    setEditRequestTypeId(data.IdRequestType);
    setSelectItDev(data.ItDev);
    setOpenEditDialog(true);
    console.log('Edit clicked for:', data);

  };


  const handleEditDialogClose = () => {
    setRequestTypeName("");
    setSelectItDev(true);
    setEditRequestTypeId(null);
    setOpenEditDialog(false);
  };

  const handleEditSubmit = () => {
    if (validateForm()) {
      const formData = new FormData();
      formData.append("RequestType", requestTypeName);
      formData.append("ItDev", selectItDev);

      var akLoginUser = JSON.parse(localStorage.getItem('user'));
      formData.append('UpdateUser', `${akLoginUser.user.IdUser}`)
      const requestOptions = {
        method: "POST",
        body: formData,
        redirect: "follow"
      };

      fetch(`${url}auth/update-request-types/${editRequestTypeId}`, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          console.log(result);
          // Update the category list after editing

          // setRequestTypes(requestTypes.map(RequestType =>
          //   RequestType.IdRequestType === editRequestTypeId
          //     ? { ...RequestType, 
          //       RequestType: requestTypeName,
          //       UpdateDate: result.request_type.UpdateDate ? dayjs(result.request_type.UpdateDate).format('DD-MM-YYYY') : '' ,
          //      }
          //     : RequestType
          // ));

          getRequestTypes();

          handleEditDialogClose();
        })
        .catch((error) => console.error("Error updating category:", error));
    }
  };

  // Function to open the Delete dialog
  const handleDeleteDialogOpen = (id) => {
    // Open your Delete confirmation dialog
    setdeleteRequestTypeId(id);
    setOpenDeleteDialog(true);
    console.log('Delete clicked for ID:', id);

  };

  // Close the confirmation dialog without deleting
  const handleDeleteDialogClose = () => {
    setdeleteRequestTypeId(null);
    setOpenDeleteDialog(false);
  };

  // Perform the delete action if confirmed
  const handleDeleteConfirm = () => {
    const requestOptions = {
      method: "DELETE",
      redirect: "follow"
    };

    fetch(`${url}auth/request-types/${deleteRequestTypeId}`, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        console.log(result);
        // Refresh the category list after deletion

        setRequestTypes(requestTypes.filter(requestType => requestType.IdRequestType !== deleteRequestTypeId));
        setOpenDeleteDialog(false);

      })
      .catch((error) => console.error("Error deleting category:", error));
  };

  // Handle Edit action
  const handleEdit = (rowData) => {
    console.log("Editing:", rowData);
    // Logic for editing the request type can be implemented here
  };

  // Handle Delete action
  const handleDelete = (id) => {
    console.log("Deleting:", id);
    // Logic for deleting the request type can be implemented here
    // Example: call API to delete the item, then update the state
  };

  // // If data is still loading or there's an error, show loading/error message
  // if (loading) {
  //   return (
  //     <DashboardLayout>
  //       <DashboardNavbar />
  //       <MDBox pt={6} pb={3} textAlign="center">
  //         <MDTypography variant="h6" color="primary">Loading Data...</MDTypography>
  //       </MDBox>
  //       <Footer />
  //     </DashboardLayout>
  //   );
  // }

  // if (error) {
  //   return (
  //     <DashboardLayout>
  //       <DashboardNavbar />
  //       <MDBox pt={6} pb={3} textAlign="center">
  //         <MDTypography variant="h6" color="error">{error}</MDTypography>
  //       </MDBox>
  //       <Footer />
  //     </DashboardLayout>
  //   );
  // }

  // Loader component for entire screen for loading states
  const renderLoader = () => (
    <Backdrop
      sx={{
        color: '#fff',
        zIndex: (theme) => theme.zIndex.drawer + 1,
        backgroundColor: 'rgba(0, 0, 0, 0.5)', // Semi-transparent black
      }}
      open={loading || formLoading}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );


  return (
    <DashboardLayout>
      <DashboardNavbar />
      {/* {renderLoader()} Display loader entire screen */}

      {/* Loader Component */}
      <Backdrop open={loading || formLoading} sx={{ color: '#fff', zIndex: 1000 }}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                // bgColor="info"  
                bgColor="#183759"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  {/* Request Types */}
                  Tipologia Richieste
                </MDTypography>
              </MDBox>

              {/* Tabs for switching between Request Type List and Add Request Type */}
              <Box sx={{ width: '100%' }}>
                <Tabs
                  value={selectedTab}
                  onChange={handleTabChange}
                  indicatorColor="primary"
                  textColor="primary"
                  variant="fullWidth"
                  aria-label="basic tabs example"
                >
                  {/* <Tab label="List Request Types" />
                  <Tab label="Add Request Type" /> */}

                  <Tab label="Elenco Tipologia Richieste" />
                  <Tab label="Nuova Tipologia Richiesta" />

                </Tabs>

                {/* Tab Content for List Request Types */}
                {selectedTab === 0 && (
                  <MDBox pt={3}>
                    <DataTable
                      table={{ columns, rows }}
                      isSorted={false}
                      // entriesPerPage={false}
                      entriesPerPage={{ defaultValue: 10 }}
                      showTotalEntries={false}
                      noEndBorder
                      currentPageIndex={currentPageIndex}
                      setCurrentPageIndex={setCurrentPageIndex}
                    />
                  </MDBox>
                )}

                {/* Tab Content for Add Request Type */}
                {selectedTab === 1 && (
                  <MDBox pt={3} px={4}>
                    {/* Add Request Type Form */}
                    <MDTypography variant="h6" mb={3} align="center">
                      {/* Add New Request Type */}
                      Aggiungi nuova Tipologia Richiesta

                    </MDTypography>
                    <Grid container spacing={2} justifyContent="center">

                      {/* ItDev Name Field */}
                      <Grid item xs={12} sm={6} md={6}>
                        <MDBox >
                          <FormControl fullWidth>
                            <InputLabel id="type-select-label1">It Dev</InputLabel>

                            <Select
                              labelId="type-select-label1"
                              id="type-select"
                              value={selectItDev ? 1 : 2}
                              label="It Dev"
                              onChange={handleItDevChange}
                              style={{ height: 45 }}
                              sx={{
                                '& .MuiSelect-icon': {
                                  display: 'block !important',  // Force icon to be visible
                                  fontSize: '1.6rem !important',  // Adjust the size of the dropdown icon
                                },
                              }}
                              IconComponent={ArrowDropDownIcon}  // Ensures the dropdown icon is displayed
                            >
                              {isLoading ? (
                                <MenuItem disabled>
                                  <CircularProgress size={24} sx={{ mr: 1 }} />
                                  Loading...
                                </MenuItem>
                              ) : itDev.length > 0 ? (
                                itDev.map((type) => (
                                  <MenuItem key={type.id} value={type.id}>
                                    {type.name}
                                  </MenuItem>
                                ))
                              ) : (
                                <MenuItem disabled>No it Dev available</MenuItem>
                              )}
                            </Select>

                          </FormControl>
                        </MDBox>
                      </Grid>

                      {/* Request Type Name Field */}
                      <Grid item xs={12} sm={8} md={6} >
                        <MDBox mb={2}>
                          <TextField
                            // label="Request Type Name"
                            label="Tipologia Richiesa"
                            variant="outlined"
                            fullWidth
                            value={requestTypeName}
                            onChange={(e) => setRequestTypeName(e.target.value)}
                            error={!!errors.name}
                            helperText={errors.name}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            sx={{
                              '& .MuiInputBase-root': { height: '45px' },
                            }}
                          />
                        </MDBox>
                      </Grid>

                      {/* Add Button */}
                      <Grid item xs={12} sm={8} md={6} lg={5}>
                        <MDBox mb={2}>
                          <Button
                            onClick={handleSubmit} // Using onClick instead of form submit
                            variant="contained"
                            color="primary"
                            fullWidth
                            sx={{
                              fontSize: '14px',
                              borderRadius: '8px',
                              height: '40px',
                              color: '#ffffff',
                              // '&:hover': {
                              //   backgroundColor: '#0b5ed7',
                              // },
                              backgroundColor: '#183759', // 💙 Base background color
                              '&:hover': {
                                backgroundColor: '#204b80', // ✨ Slightly lighter hover
                              },
                            }}
                          >
                            {/* Add Request Type */}
                            Salva
                          </Button>
                        </MDBox>
                      </Grid>
                    </Grid>
                  </MDBox>
                )}
              </Box>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={openDeleteDialog}
        onClose={handleDeleteDialogClose}
        fullWidth
        maxWidth="sm"
      >
        {/* <DialogTitle>Confirm Deletion</DialogTitle>  */}
        <DialogTitle>Conferma l'eliminazione</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {/* Are you sure you want to delete this category? This action cannot be undone. */}

            Sei sicuro di voler eliminare questa categoria? Questa azione non può essere annullata.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteDialogClose} color="primary">
            {/* Cancel */}
            Annulla
          </Button>
          <Button onClick={handleDeleteConfirm} color="error">
            Cancella
          </Button>
        </DialogActions>
      </Dialog>

      {/* Edit Confirmation Dialog */}
      <Dialog
        open={openEditDialog}
        onClose={handleEditDialogClose}
        fullWidth
        maxWidth="sm"
      >
        {/* <DialogTitle>Edit Request Type</DialogTitle> */}
        <DialogTitle>Modifica Tipo Richiesta</DialogTitle>
        <DialogContent>

          <FormControl fullWidth sx={{ marginBottom: 2, mt: 2 }}>
            <InputLabel id="type-select-label1">It Dev</InputLabel>
            <Select
              labelId="type-select-label1"
              id="type-select"
              value={selectItDev ? 1 : 2}
              label="It Dev"
              onChange={handleItDevChange}
              style={{ height: 45 }}
              sx={{
                '& .MuiSelect-icon': {
                  display: 'block !important',  // Force icon to be visible
                  fontSize: '1.6rem !important',  // Adjust the size of the dropdown icon
                },
              }}
              IconComponent={ArrowDropDownIcon}  // Ensures the dropdown icon is displayed
            >
              {isLoading ? (
                <MenuItem disabled>
                  <CircularProgress size={24} sx={{ mr: 1 }} />
                  Loading...
                </MenuItem>
              ) : itDev.length > 0 ? (
                itDev.map((type) => (
                  <MenuItem key={type.id} value={type.id}>
                    {type.name}
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>No It Dev available</MenuItem>
              )}
            </Select>
          </FormControl>

          <TextField
            // label="Request Type" 
            label="Tipo Richiesta"
            variant="outlined"
            fullWidth
            value={requestTypeName}
            onChange={(e) => setRequestTypeName(e.target.value)}
            error={!!errors.name}
            helperText={errors.name}
            InputLabelProps={{ shrink: true }}
            sx={{ marginBottom: 2, mt: 2 }}

          />

        </DialogContent>
        <DialogActions>
          <Button onClick={handleEditDialogClose} color="primary">
            {/* Cancel */}
            Annulla
          </Button>
          <Button onClick={handleEditSubmit} color="primary">
            {/* Save */}
            Salva
          </Button>
        </DialogActions>
      </Dialog>


    </DashboardLayout>
  );
}

export default Tables;
